module.exports = __webpack_public_path__ + "img/flask-round-potion.daf6eba9.svg";